import { render } from "./Data.vue?vue&type=template&id=8e6dbeac&scoped=true"
import script from "./Data.vue?vue&type=script&lang=js"
export * from "./Data.vue?vue&type=script&lang=js"

import "./Data.vue?vue&type=style&index=0&id=8e6dbeac&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\Rufiz Huseynzada\\OneDrive - Azerbaijan State Oil and Industry University\\Desktop\\ProgressProjects\\LifeInsureance\\web\\LifeInsurance\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8e6dbeac"]])

export default __exports__